import { useState, memo, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { ActionHandlerFunction, IActionHandler } from "@preveil-api";
import { AdminUIActionTypes, GlobalErrorMessages, Message, MessageAnchors, MessageHandlerDisplayType, useAppDispatch, FileUploadTypes } from "src/common";
import { DraggableContainer } from "src/components";
import { uiActions } from "src/store/ui-manager/slice";
import _ from "lodash";

type AllProps = {
    show_modal: boolean;
    handleAction: ActionHandlerFunction;
}

// Description: Add certificate modal component for the device settings page
function AddCertificateComponent(props: AllProps) {
    const { show_modal, handleAction } = props;
    const dispatch = useAppDispatch();
    const [certificate, setCertificate] = useState<string>();
    const [is_certificate_valid, setIsCertificateValid] = useState<boolean>(false);

    // Description: Enable the save button only if the certificate is valid
    useEffect(() => {
        !!certificate ? setIsCertificateValid(true) : setIsCertificateValid(false);
    }, [certificate]);

    function handlePageActions(action_obj: IActionHandler) {
        if (action_obj.actionType === AdminUIActionTypes.DeviceCertificateData) {
            const { cert } = action_obj.params;
            setCertificate(cert);
        } else if (action_obj.actionType === AdminUIActionTypes.PageError) {
            const { message, stack } = action_obj.params;
            dispatch(uiActions.handleRequestErrors(new Message(message, MessageHandlerDisplayType.toastr), stack));
        } else {
            const message = GlobalErrorMessages.no_handler_found.replace(MessageAnchors.actionType, action_obj.actionType);
            dispatch(uiActions.handleRequestErrors(new Message(message, MessageHandlerDisplayType.toastr), action_obj));
        }
    }

    function handleShowModal() {
        handleReset();
        handleAction({ actionType: AdminUIActionTypes.ShowModal });
    }

    function handleReset() {
        setCertificate("");
        setIsCertificateValid(false);
    }

    function handleSubmit(): void {
        if (is_certificate_valid) {
            handleAction({ actionType: AdminUIActionTypes.UploadDeviceCertificate, params: { certificate } });
            handleShowModal();
        }
    }

    return <Modal
        size="lg"
        show={show_modal}
        onHide={handleShowModal}
        centered
        aria-label="Device Access Requirements">
        <Modal.Header closeButton>
            <Modal.Title>Device Access Requirements</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div>
                {!certificate ? 
                    <DraggableContainer handleAction={handlePageActions} file_upload_type={FileUploadTypes.CERTIFICATE}/>
                    : <div className="certificate-display"><p>{certificate}</p></div>
                }
                <div className="btn-panel mt-4">
                    <Button disabled={!is_certificate_valid} onClick={handleSubmit}>Save</Button>
                    <Button disabled={_.isEmpty(certificate)} variant="no-outline-primary" onClick={() => handleReset()}>Reset</Button>
                    <Button variant="no-outline-primary" onClick={() => handleShowModal()}>Cancel</Button>
                </div>
            </div>
        </Modal.Body>
    </Modal>;
}

export default memo(AddCertificateComponent);
